module.exports = __webpack_public_path__ + "static/media/makkan-badge.a3df6038.png";